var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgGif = function SvgGif(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50CCC7",
    fillRule: "evenodd",
    d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0v4a2 2 0 0 0 2 2h4z",
    opacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 8,
    x: 2,
    y: 13,
    fill: "#F7F8FA",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#50CCC7",
    d: "M7.76 16.325a.66.66 0 0 0-.264-.369.7.7 0 0 0-.222-.097 1 1 0 0 0-.275-.034q-.3 0-.522.137a.9.9 0 0 0-.337.4q-.12.26-.12.632.001.375.116.64.116.263.333.402a.97.97 0 0 0 .53.139q.274 0 .465-.084a.64.64 0 0 0 .29-.241.67.67 0 0 0 .1-.367l.186.02H7.033v-.686h1.785v.516q0 .522-.237.895-.234.374-.646.572-.41.2-.944.2-.593 0-1.041-.241-.449-.241-.7-.689Q5 17.621 5 17.006q0-.48.152-.85.15-.372.422-.631.273-.259.63-.392.36-.133.775-.133.36 0 .669.097t.55.274.39.42.185.534zM10.977 15.053v3.894h-1v-3.894zM12.174 18.947v-3.894H15v.765h-1.825v.798h1.645v.766h-1.645v1.565z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGif);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;